import { MenuEntry } from '@src/menu-entry.js';

export default MenuEntry.create()
    .setTitle('Pickwagen verräumen')
    .setRoute('empty-out-picking-cart_show');
